import styles from './Input.module.css'

interface Input {
  id: string,
  type: string,
  placeholder: string,
  value: string,
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void,
  error?: boolean,
  errorText?: string
  icon?: React.ReactNode
  errorIcon?: React.ReactNode
  required?: boolean
}

function Input({ id, type = 'text', placeholder, value, onChange, error, errorText, icon, errorIcon, required = false }: Input) {
  return (
    <div className={styles.container}>
      <input
        id={id}
        className={error ? styles.inputError : styles.input
        }
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        required={required}
      />
      {icon && <span className={styles.icon}>{icon}</span>}
      {error && <p className={styles.errorText}> 
        {errorIcon && <span className={styles.errorIcon}>{errorIcon}</span>}
        {errorText}</p>
      }
    </div>
  )
}

export default Input
